import * as React from "react";
import BackButton from "../../core/BackButton/BackButton";
import Spinner from "../../core/Spinner/Spinner";
import { ITranslationProps, translateComponent } from "../../helpers/translation";

interface ILoginToClientProps extends ITranslationProps {
    onSubmit: (password: string) => Promise<boolean>;
}

interface ILoginToClientState {
    password: string;
    validated: boolean;

    requestFailed: boolean;
    processing: boolean;
}

class LoginToClient extends React.Component<ILoginToClientProps, ILoginToClientState> {
    private formElement: HTMLFormElement | null;

    constructor(props: ILoginToClientProps) {
        super(props);

        this.state = {
            password: "",
            validated: false,
            requestFailed: false,
            processing: false,
        };

        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.onLoginToClientClick = this.onLoginToClientClick.bind(this);
        this.inputKeypress = this.inputKeypress.bind(this);
    }

    public render() {
        return (
            <div>
                {this.state.processing && <Spinner />}
                <BackButton />
                <h2>{this.props.t("LoginToClient.Title")}</h2>
                <div className="mb-3">{this.props.t("LoginToClient.Instructions")}</div>
                <form ref={ref => this.formElement = ref} className={this.state.validated ? "was-validated" : "needs-validation"} noValidate={true}>
                    <div className="form-group">
                        <label>{this.props.t("LoginToClient.Password")}</label>
                        <input
                            type="password"
                            className="form-control"
                            placeholder={this.props.t("LoginToClient.Password")}
                            value={this.state.password}
                            onChange={this.onPasswordChange}
                            onKeyPress={this.inputKeypress}
                            required={true}
                            autoFocus={true} />

                        <div className="invalid-feedback">
                            {this.props.t("LoginToClient.PasswordValidationMessage")}
                        </div>
                    </div>

                    <button type="button" className="btn btn-primary" onClick={this.onLoginToClientClick}>{this.props.t("LoginToClient.LoginToClientButton")}</button>

                    {this.state.requestFailed && <div className="mt-3 alert alert-danger">{this.props.t("LoginToClient.FailureMessage")}</div>}
                </form>
            </div>
        );
    }


    private onPasswordChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({ password: event.target.value });
    }

    private inputKeypress(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.key === "Enter") {
            event.preventDefault();
            this.onLoginToClientClick();
        }
    }

    private async onLoginToClientClick(): Promise<void> {
        this.setState({ validated: true });

        if (this.formElement && this.formElement.checkValidity()) {
            this.setState({ processing: true }, async () => {
                const result = await this.props.onSubmit(this.state.password);
                this.setState({ requestFailed: !result, processing: false, password: "" });
            });
        }
    }

}

export default translateComponent(LoginToClient);



// WEBPACK FOOTER //
// ./src/components/LoginToClient/LoginToClient.tsx